import { differenceInMonths, format, formatDistanceToNow } from 'date-fns'

export const getDistanceInWords = (time: string) => {
    const now = new Date()
    const ogDate = new Date(time)
    const timeDiff = Math.abs((now as any) - (ogDate as any))

    // less than an hour show Just now
    if (timeDiff < 60 * 60 * 1000) {
        return 'Just now'
    }

    // if the date is longer than a month ago, just show the date
    if (differenceInMonths(ogDate, now) < -1) {
        return format(ogDate, 'MMM d, yyyy')
    }

    return formatDistanceToNow(ogDate, { addSuffix: true }) // ex: about 1 hour ago
        .replace(/about /gi, '') // remove 'about'
        .replace(/ minutes?/gi, 'm') // 1m
        .replace(/ hours?/gi, 'h') // 1h
        .replace(/ days?/gi, 'd') // 1d
        .replace(/ months?/gi, 'mo') // 1mo
}
